import React from "react";
import { FaTimesCircle } from "react-icons/fa";

const ErrorMessage = ({ message }) => {
  if (!message) return null;

  return (
    <div className="mb-4 bg-red-50 border border-red-200 rounded-lg p-4">
      <div className="flex">
        <FaTimesCircle className="h-5 w-5 text-red-400" />
        <div className="ml-3">
          <p className="text-sm text-red-800">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
